/**
 * Returns an opaque base-36 hash prefix for `capacitor-secure-storage-plugin` keys
 * so the raw server entity ID is never visible in the stored key name
 * (e.g. `cap_sec_3_cache_jobs`).
 *
 * Algorithm: FNV-1a 32-bit — deterministic, zero dependencies, O(digits) time.
 *
 * @param entityId - Process server entity ID from the JWT (`token.user.entityId`).
 * @returns An opaque fixed-length base-36 string unique to `entityId`.
 *
 * @example
 * storagePrefix(3)  // → "1r5tdzm" (never "3")
 * storagePrefix(10) // → "1r5tgf4" (never "10")
 */
export function storagePrefix(entityId: number): string {
  let h = 0x811c9dc5;
  for (const c of String(entityId)) {
    h = (Math.imul(h ^ c.charCodeAt(0), 0x01000193)) >>> 0;
  }
  return h.toString(36);
}
